import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  statusIcon: {
    fontSize: '1rem',
    lineHeight: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: theme.spacing(3.5),
    height: theme.spacing(3.5),
    borderRadius: '10px',
  },

  notStarted: {
    opacity: 0.3,
    backgroundColor: `${theme.palette.secondary.main} !important`,

    '& svg': {
      color: `${theme.palette.font.primary} !important`,
    },
  },
  doLate: {
    backgroundColor: `${theme.palette.warningSamitransparent} !important`,

    '& svg': {
      color: `${theme.palette.warning.main} !important`,
    },
  },
  skipped: {
    backgroundColor: `${theme.palette.errorSamitransparent} !important`,

    '& svg': {
      color: `${theme.palette.error.main} !important`,
    },
  },
  finished: {
    backgroundColor: `${theme.palette.successSamitransparent} !important`,

    '& svg': {
      color: `${theme.palette.success.main} !important`,
    },
  },
}));
